import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { MatDialogModule } from "@angular/material/dialog";
import { AppMatModule } from "../shared/app-mat.module";
import { MatExpansionModule } from "@angular/material/expansion";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { SurveyPageComponent } from "./survey-page/survey-page.component";
import { SurveyModule } from "../shared/survey/survey.module";
import { SurveysRoutingModule } from "./surveys-routing.module";

@NgModule({
  declarations: [SurveyPageComponent],
  imports: [
    CommonModule,
    SurveyModule,
    SurveysRoutingModule,
    SharedModule,
    AppMatModule,
    MatDialogModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [SurveysRoutingModule],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: "en-US" }],
})
export class SurveysModule {}
